import styled from 'styled-components';
import { FaArrowDown } from 'react-icons/fa';

interface ScrollDownButtonProps {
  visible: boolean;
  onClick: () => void;
  sidePanel?: boolean;
}

const ScrollDownButton = ({ visible, onClick, sidePanel = false }: ScrollDownButtonProps) => {
  if (!visible) return null;
  
  return (
    <ScrollButton onClick={onClick} sidePanel={sidePanel}>
      <FaArrowDown />
    </ScrollButton>
  );
};

export default ScrollDownButton;

const ScrollButton = styled.button<{ sidePanel?: boolean }>`
  position: fixed;
  bottom: 150px;
  right: ${({ sidePanel }) => sidePanel ? '480px' : '50px'};
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #0084ff;
  color: white;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 5px rgba(0,0,0,0.2);
  z-index: 1000;
  transition: all 0.3s ease;

  &:hover {
    background-color: #0073e6;
    transform: scale(1.1);
  }

  svg {
    width: 20px;
    height: 20px;
  }
`;